import React from 'react';
import { styled, Tooltip } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';
import { Row } from 'components/SectionedTable';

const StyledInfoOutlined = styled(InfoOutlined)(({ theme }) => ({
  marginLeft: theme.spacing(0.5),
  color: theme.palette.text.darkBodyText,
}));

const InfoTooltipIcon: React.FC<{ title: string }> = ({ title }) => (
  <Tooltip title={title}>
    <StyledInfoOutlined fontSize="small" />
  </Tooltip>
);

const LabelWrapper = styled('span')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(0.5),
}));

const LabelCell: React.FC<{ row: Row }> = ({ row }) => {
  return (
    <LabelWrapper>
      {row.label}
      {row.tooltip && <InfoTooltipIcon title={row.tooltip} />}
    </LabelWrapper>
  );
};

export default LabelCell;
